module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/12-83fd57650d3d54639a079edbee159ea3.jpg";